<template>
  <v-form @submit.prevent="search" class="search-home-form" ref="form">
    <BusinessSelect
      background-color="transparent"
      hide-details
      height="48px"
      clearable
      :dark="dark"
      solo
    />
    <CategoriesSelect
      background-color="transparent"
      hide-details
      height="48px"
      :dark="dark"
      solo
    />
    <DistrictsSelect
      background-color="transparent"
      hide-details
      height="48px"
      :dark="dark"
      solo
    />
    <ReferenceField
      background-color="transparent"
      hide-details
      height="48px"
      :dark="dark"
      solo
    />

    <ButtonWidget :color="!dark ? 'primary' : 'white'" type="submit" block>
      <div :class="!dark ? 'white--text' : 'primary--text'">Buscar</div>
      <v-icon :color="!dark ? 'white--text' : 'primary'" right>
        fa-search
      </v-icon>
    </ButtonWidget>
  </v-form>
</template>

<script>
import BusinessSelect from "./fields/BusinessSelect.vue";
import CategoriesSelect from "./fields/CategoriesSelect.vue";
import DistrictsSelect from "./fields/DistrictsSelect.vue";
import ReferenceField from "./fields/ReferenceField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    search() {
      const form = this.$refs.form;
      const formData = new FormData(form.$el);
      var path = "/busca";

      const parameters = [];

      for (var pair of formData.entries()) {
        if (pair[0] === "finalidade" && pair[1])
          path += pair[1] === "Aluguel" ? "/locacao" : "/imoveis";
        else if (pair[0] !== "finalidade" && pair[1])
          parameters.push(
            encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1])
          );
      }

      if (parameters.length) path += "?" + parameters.join("&");

      this.$router.push({ path });
    },
  },
  components: {
    BusinessSelect,
    CategoriesSelect,
    DistrictsSelect,
    ReferenceField,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.search-home-form::v-deep {
  display: grid;
  gap: 16px;
  grid-template-columns:
    calc(25% - 58px) calc(25% - 58px) calc(25% - 58px) calc(25% - 58px)
    170px;

  @media screen and (max-width: 959.9px) {
    grid-template-columns: 1fr;
  }

  .theme--dark {
    &.v-text-field--outlined {
      fieldset {
        border-color: #ffffff;

        @media screen and (max-width: 959.9px) {
          border-color: rgba(204, 190, 192, 0.8);
        }
      }

      input {
        &::placeholder {
          color: #ffffff;

          @media screen and (max-width: 959.9px) {
            color: var(--v-primary-lighten1);
          }
        }
      }
    }
  }
}
</style>
